import HttpClient from "./HttpClient.js";

export default class Repository {
  private _client = new HttpClient();

  public async search(
    keyword: string,
    targetMainTitle: boolean,
    targetPartTitle: boolean,
    targetReport: boolean,
    start: string,
    end: string,
    needsReports: boolean,
    researcherName: string,
    targetMainName: boolean,
    targetPartName: boolean,
    affiliation: string,
    targetMainAffiliation: boolean,
    targetPartAffiliation: boolean
  ): Promise<string>{
    return this._client.get("researches/search" 
      + "?" + "keyword=" + keyword 
      + "&" + "targetMainTitle=" + targetMainTitle.toString()
      + "&" + "targetPartTitle=" + targetPartTitle.toString()
      + "&" + "targetReport=" + targetReport.toString()
      + "&" + "start=" + start
      + "&" + "end=" + end
      + "&" + "needsReports=" + needsReports.toString()
      + "&" + "researcherName=" + researcherName
      + "&" + "targetMainName=" + targetMainName.toString()
      + "&" + "targetPartName=" + targetPartName.toString()
      + "&" + "affiliation=" + affiliation
      + "&" + "targetMainAffiliation=" + targetMainAffiliation.toString()
      + "&" + "targetPartAffiliation=" + targetPartAffiliation.toString()
      );
  }

  public async getEach(id: number): Promise<string>{
    return this._client.get("researches/" + id.toString());
  }
}